<template>
  <div id="app">
    <md-toolbar>
      <template v-if="isSignIn">
        <h1 class="md-title" style="flex: 1;">MarkdDrive {{ filename }}</h1>
        <md-button class="user-sidenav-toggle md-icon-button" @click="toggleSideNav">
          <md-icon>account_circle</md-icon>
        </md-button>
      </template>
      <template v-else>
        <h1 class="md-title" style="flex: 1;">MarkdDrive</h1>
        <md-button class="md-button" @click="login">
          <md-icon>face</md-icon>
          <span>Sign in</span>
        </md-button>
      </template>
    </md-toolbar>
    <div class="main-content">
      <template v-if="isSignIn">
        <DriveFileList class="file-list"></DriveFileList>
        <Editor :value="value"></Editor>
      </template>
    </div>
    <md-sidenav class="user-sidenav md-right md-fixed" ref="sideNav" v-if="isSignIn">
      <md-toolbar class="md-large">
        <md-avatar class="md-large" style="margin: 16px;">
          <img :src="userImageUrl" alt="People">
        </md-avatar>
        <div class="md-title" style="flex: 1;">{{ username }}</div>
      </md-toolbar>
      <md-layout md-column class="sidenav-content">
        <md-layout style="overflow-y: auto;">
          <md-list class="user-actions" style="width: 100%;">
            <md-list-item>
              <md-icon>settings</md-icon>
              <span>Settings</span>
              <md-list-expand>
                <md-list class="user-actions">
                  <md-list-item class="md-inset">
                    <md-checkbox>Debug mode</md-checkbox>
                  </md-list-item>
                </md-list>
              </md-list-expand>
            </md-list-item>
            <!--<md-list-item>-->
              <!--<md-icon>account_circle</md-icon>-->
              <!--<span>Plop</span>-->
              <!--<md-list-expand>-->
                <!--<md-list class="user-actions">-->
                  <!--<md-list-item class="md-inset">World</md-list-item>-->
                  <!--<md-list-item class="md-inset">Americas</md-list-item>-->
                  <!--<md-list-item class="md-inset">Europe</md-list-item>-->
                <!--</md-list>-->
              <!--</md-list-expand>-->
            <!--</md-list-item>-->
          </md-list>
        </md-layout>
        <md-layout md-flex="10">
          <md-button class="md-button" @click="openDialog('aboutDialog')">
            <md-icon>info_outline</md-icon>
            <span>About</span>
          </md-button>
          <md-button class="md-button" @click="logout" style="flex: 1;">
            <md-icon>exit_to_app</md-icon>
            <span>Sign out</span>
          </md-button>
        </md-layout>
      </md-layout>
    </md-sidenav>
    <md-dialog class="dialog" md-open-from="#about" md-close-to="#about" ref="aboutDialog">
      <md-dialog-title>About MarkdDrive</md-dialog-title>

      <md-dialog-content>
        <p style="margin-bottom: 42px">{{ packageInfo.description }}</p>
        <md-list class="list">
          <md-list-item>v{{ packageInfo.version }}</md-list-item>
          <md-list-item>License: {{ packageInfo.license }}</md-list-item>
          <md-list-item><a :href="packageInfo.homepage" target="_blank">Home page</a></md-list-item>
          <md-list-item><a :href="packageInfo.bugs.url" target="_blank">Report a bug</a></md-list-item>
        </md-list>
      </md-dialog-content>
      <md-dialog-actions>
        <md-button class="md-primary button" @click="closeDialog('aboutDialog')">Close</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
  import Vue from 'vue';
  import Editor from './components/Editor';
  import DriveFileList from './components/DriveFileList';
  import MarkdDriveJSON from '../package.json';

  export default {
    name: 'app',

    components: {
      Editor,
      DriveFileList,
    },

    data() {
      return {
        value: '',
        isSignIn: false,
        currentFile: {},
        basicProfile: {},
        packageInfo: MarkdDriveJSON,
      };
    },

    computed: {
      filename() {
        if (this.currentFile && this.currentFile.name !== undefined) {
          return ` - ${this.currentFile.name}`;
        }
        return '';
      },
      username() {
        try {
          return this.basicProfile.getName();
        } catch (e) {
          return '';
        }
      },
      userImageUrl() {
        try {
          return this.basicProfile.getImageUrl();
        } catch (e) {
          return '';
        }
      },
    },

    created() {
      Vue.googleDrive.on('gapi.auth2:loaded', (isSignIn) => {
        this.isSignIn = isSignIn;
        if (isSignIn) {
          this.basicProfile = Vue.googleDrive.user.getBasicProfile();
        } else {
          this.basicProfile = {};
          this.currentFile = {};
        }
      });
      Vue.googleDrive.on('isSignInChanged', (newIsSignIn) => {
        this.isSignIn = newIsSignIn;
        if (newIsSignIn) {
          this.basicProfile = Vue.googleDrive.user.getBasicProfile();
        } else {
          this.basicProfile = {};
          this.currentFile = {};
        }
      });
    },

    mounted() {
      this.$events.on('edit-file', (file) => {
        this.currentFile = file;
      });
      this.$events.on('file-delete', (file) => {
        if (this.currentFile && this.currentFile.id === file.id) {
          this.currentFile = {};
        }
      });
    },

    methods: {
      logout() {
        Vue.googleDrive.signOut().then(() => {
          this.isSignIn = Vue.googleDrive.isSignIn;
          if (!this.isSignIn) {
            this.basicProfile = {};
            this.currentFile = {};
          }
        });
      },
      login() {
        Vue.googleDrive.signIn().then(() => {
          this.isSignIn = Vue.googleDrive.isSignIn;
          this.basicProfile = Vue.googleDrive.user.getBasicProfile();
        });
      },
      toggleSideNav() {
        this.$refs.sideNav.toggle();
      },

      openDialog(ref) {
        this.$refs[ref].open();
      },

      closeDialog(ref) {
        this.$refs[ref].close();
      },
    },
  };
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic');
  @import url('https://fonts.googleapis.com/icon?family=Material+Icons');

  @import './assets/theme';

  ::-webkit-scrollbar {
    $scrollbar-size: 0.65em;
    width: $scrollbar-size;
    height: $scrollbar-size;

    &-thumb {
      background-color: rgba($grey, 0.3);
      border-radius: 42px;
    }
  }

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;
    height: 100vh;
  }

  .main-content {
    position: relative;
    height: calc(100% - 64px);
    display: flex;

    > .file-list {
      min-width: 320px;
    }
  }

</style>

<style lang="scss" scoped>
  @import './assets/colors';

  .md-theme-default {
    &.md-toolbar {
      background: lighten($black, 10%);
    }
  }

  .md-sidenav {
    z-index: 1000;
  }
</style>


// WEBPACK FOOTER //
// src/App.vue?49cabd02